module.exports = __webpack_public_path__ + "media/images/abatible-15d00bae.png";